import React, { useEffect } from 'react'
import { Button, Grid, List, ListItem, ListItemIcon, DialogContent, Box, Typography, Dialog, DialogTitle, DialogActions, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { DateTimePicker, DatePicker as KendoDatePicker, TimePicker } from "@progress/kendo-react-dateinputs";
import CircleIcon from '@mui/icons-material/Circle';
import { RadioButton } from '@progress/kendo-react-inputs';
import moment from 'moment';
import WindowComponent from '../Window/WindowComponent.jsx';
import getSetDataService from '../../../../shared/common-utilities/services/getSetDataService.jsx';
import { PlanFunctionsForFlag } from '../../../../shared/common-utilities/enums/PlanFunctionsEnum.jsx';
import IconButton from '@mui/material/IconButton';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { parse } from 'date-fns';
import { CommonConst as Consts } from '../../../../shared/common-utilities/enums/CommonConst.jsx';

let service = getSetDataService();

const ModalComponent = (props) => {
    const {id, parameters, obj} = props?.params

    const [formData, setFormData] = React.useState([]);
    const [yesButton, setYesButton] = React.useState(false);

    useEffect(() => {
        const formParametrs = [];
        if (props?.params?.parameters) {
            for (const parameter of props.params.parameters) {
                if ((parameter.type === 'Edm.DateTime' || parameter.type === 'Edm.Date' || parameter.type === 'Edm.TimeOfDay') && parameter.defaultValue) {
                    // Remove 'Z' to stop converting in into local timezone                    
                    parameter.value = new Date(parameter?.defaultValue?.toString()?.toUpperCase().replace('Z', ''));
                    if(parameter.type === 'Edm.TimeOfDay') {
                        if(isNaN(new Date(parameter.defaultValue).getTime())) {
                            const today = new Date();
                            const [hours, minutes, seconds] = parameter?.defaultValue?.split(':').map(Number);
                            today.setHours(parseInt(hours, 10));
                            today.setMinutes(parseInt(minutes, 10));
                            today.setSeconds(parseInt(seconds, 10));
                            parameter.value = new Date(today);
                        } else
                            parameter.value = new Date(parameter.defaultValue);
                    }
                } else if (props.params?.for === PlanFunctionsForFlag.PlanMovementsNewConfirmation || props.params?.for === PlanFunctionsForFlag.NewpartialTrip) {
                    if (parameter.type === 'Dialog.SelectRadioButton') {
                        parameter.value = parameter.defaultValue;
                    } else if (parameter.type === 'Dialog.ConfirmSingleLine') {
                        parameter.value = parameter.stopOnCancel;
                    }
                } else if (parameter.type === 'Dialog.ConfirmSingleLine') {
                    parameter.value = parameter.stopOnCancel;
                    if (!parameter.stopOnCancel) {
                        setYesButton(true);
                    }
                } else if (props.params?.for === PlanFunctionsForFlag.ShowDetailsActionItemRemark) {
                    if (parameter.type === 'Edm.String') {
                        parameter.value = parameter.defaultValue;
                    } else if (parameter.type === 'APIGrid' && parameter.name === 'agendaCode') {
                        let newData = props?.params?.options.find((item)=> item.code == parameter.defaultValue)
                        parameter.value = newData
                    }
                } else if (parameter.type === 'Dialog.Message' && props.params?.for === PlanFunctionsForFlag.CreateTrip) {
                    parameter.value = true;
                } else {
                    parameter.value = '';
                }
                formParametrs.push(parameter);
            }
            setFormData(formParametrs);
        } else if (props.params?.for === PlanFunctionsForFlag.PlanMovementsNewNotification) {
            setTimeout(() => {
                props.closeConfirmationModal(null, props.params?.for);
            }, 3000);
        }
    }, [props.params?.for]);

    const validateDropdown = () => {
        if (props.params?.for === PlanFunctionsForFlag.DeleteDepot || props.params?.for === PlanFunctionsForFlag.DeleteHookOff || props.params?.for === PlanFunctionsForFlag.DeleteTerminal ||
            props.params?.for === PlanFunctionsForFlag.HookOff || props.params?.for === PlanFunctionsForFlag.CustomHookOff || props.params?.for === PlanFunctionsForFlag.CreateTrip ||
            props.params?.for === PlanFunctionsForFlag.InsertExtraAction ||  props.params?.for === PlanFunctionsForFlag.ShowDetailsActionItemRemark ||props.params?.for === PlanFunctionsForFlag.AgendaItem) {
            const tempFormData = formData;
            for (const formData of tempFormData) {
                if ((formData.value === null || formData.value === undefined || formData.value === '') && (formData?.type != 'Label' && formData?.type != 'Edm.String') ) {
                    formData.isRequired = true;
                } else {
                    formData.isRequired = false;
                }
            }
            setFormData([...tempFormData]);
        }
    };

    const onOkClick = () => {
        validateDropdown();
        if (props.params?.for === PlanFunctionsForFlag.DeleteDepot || props.params?.for === PlanFunctionsForFlag.DeleteHookOff || props.params?.for === PlanFunctionsForFlag.DeleteTerminal
            || props.params?.for === PlanFunctionsForFlag.CustomHookOff || props.params?.for === PlanFunctionsForFlag.HookOff || props.params?.for === PlanFunctionsForFlag.Postpone) {
            if (checkFormData(formData)) {
                return;
            }
            const combineObject = [];
            for (const item of formData) {
                if (item.type === 'Dialog.SelectMenuSingle') {
                    combineObject.push({ [item.name]: item.value.name });
                } else if (item.type === 'Edm.DateTime') {
                    combineObject.push({ [item.name]: item.value });
                } else if (item.type === 'Edm.Date') {
                    combineObject.push({ [item.name]: moment(item.value).format('yyyy-MM-DD') });
                }
            }
            const selectedValue = getSelectedValue(combineObject);
            if ((props.params?.for === PlanFunctionsForFlag.HookOff || props.params?.for === PlanFunctionsForFlag.CustomHookOff) && props?.params?.options) {
                const options = props?.params?.options;
                if (options[0]?.transportAddress) {
                    selectedValue.transportAddress = options[0].transportAddress;
                }
                if (props.params?.for === PlanFunctionsForFlag.CustomHookOff && options[0]?.hookOffActionCode && options[0]?.hookOnActionCode) {
                    selectedValue.hookOffActionCode = options[0].hookOffActionCode;
                    selectedValue.hookOnActionCode = options[0].hookOnActionCode;
                }
            }
            const obj = service.movementLinesAndOperationDeatilObject(props.params?.movementlines, JSON.stringify(selectedValue));
            closeModalAndResetState(obj, props.params?.for);
        } else if (props.params?.for === PlanFunctionsForFlag.WarningsMoveUp || props.params?.for === PlanFunctionsForFlag.WarningsMoveDown || props.params?.for === PlanFunctionsForFlag.RegroupTrip) {
            let obj = {
                "input": "{\"warnings\":true}"
            };
            if (props.params?.for === PlanFunctionsForFlag.RegroupTrip) {
                obj = {
                    "input": "{\"confirmation\":true}"
                };
            }
            setFormData([]);
            setYesButton(false);
            props.closeConfirmationModal(obj, props.params?.for, props.params?.id);
        } else if (props.params?.for === PlanFunctionsForFlag.SetFree || props.params?.for === PlanFunctionsForFlag.SetFreeRoutes) {
            const combineObject = [];
            for (const item of formData) {
                if (item.type === 'Dialog.ConfirmSingleLine') {
                    if (yesButton) {
                        combineObject.push({ [item.name]: true });
                    } else {
                        combineObject.push({ [item.name]: item.value });
                    }
                }
            }
            const selectedValue = getSelectedValue(combineObject);
            setAdditionalValues(selectedValue);
            const gridFlagVal = props.params?.for === PlanFunctionsForFlag.SetFreeRoutes ? 'routes' : 'movements';
            const obj = service.movementLinesAndOperationDeatilObject(props.params?.movementlines, JSON.stringify(selectedValue), gridFlagVal);
            closeModalAndResetState(obj, props.params?.for);
        } else if (props.params?.for === PlanFunctionsForFlag.CalculateConfirmation) {
            const obj = {
                "input": "{\"warnings\":true}"
            }
            closeModalAndResetState(obj, props.params?.for);
        } else if (props.params?.for === PlanFunctionsForFlag.PlanMovementsNewConfirmation || props.params?.for === PlanFunctionsForFlag.NewpartialTrip) {
            const combineObject = [];
            for (const item of formData) {
                if (item.type === 'Dialog.SelectRadioButton') {
                    combineObject.push({ [item.name]: item.value == "" ? "1" : item.value });
                } else if (item.type === 'Dialog.ConfirmSingleLine') {
                    combineObject.push({ [item.name]: item.value });
                } else {
                    combineObject.push({ [item.name]: moment(item.value).format('YYYY-MM-DD') });
                }
            }
            let selectedValue = getSelectedValue(combineObject);

            if (props?.params?.input && 'rePlan' in props?.params?.input) {
                selectedValue.planOnPartialTrip = props?.params?.input?.planOnPartialTrip
                selectedValue.rePlan = true
                if('planningChoice' in props?.params?.input) {
                    selectedValue.planningChoice = props?.params?.input?.planningChoice
                }
            }
            
            setAdditionalValues(selectedValue);
            let obj = {}
            if (props.params?.for === PlanFunctionsForFlag.PlanMovementsNewConfirmation) {
                if('planOnPartialTrip' in JSON.parse(props?.params?.obj)) {
                    selectedValue = { ...selectedValue, ...JSON.parse(props?.params?.obj) };
                }
                obj = service.movementLinesAndOperationDeatilObject(props.params?.movementlines, JSON.stringify(selectedValue));
            } else {
                obj = {
                    "input": JSON.stringify(selectedValue)
                }
            }
            closeModalAndResetState(obj, props.params?.for);
        } else if (props.params?.for === PlanFunctionsForFlag.ChangePTResourceConfirmation) {            
            let obj = props.params?.obj || {};
            const objId = props.params?.id;

            for (const item of formData) {
                if (item.type === 'Dialog.SelectRadioButton') {
                    obj[item.name] = item.value
                } else {
                    obj.data = props?.params?.result?.data ? props?.params?.result?.data : {}
                    obj.warnings = true;
                }
            }
            closeModalAndResetState(obj, props.params?.for, objId);
        } else if ([PlanFunctionsForFlag.DeleteSelection,PlanFunctionsForFlag.RemoveFromCurrentResource,PlanFunctionsForFlag.DeletePartialTrip].includes(props.params?.for)) {
            const obj = props.params?.result;
            closeModalAndResetState(obj, props.params?.for,props.params?.id);
        } else if (props.params?.for === PlanFunctionsForFlag.ChangeSequence) {
            let newObj = obj;
            const input = JSON.parse(newObj.input);
            input.warnings = true
            newObj.input = JSON.stringify(input)
            closeModalAndResetState(newObj, props.params?.for, id);
        } else if (props.params?.for === PlanFunctionsForFlag.MoveMovement) {
            const obj = props.params?.obj;

            const combineObject = [];
            for (const item of formData) {
                if (item.type === 'Dialog.ConfirmSingleLine') {
                    combineObject.push({ 'data': props?.params?.result ? props?.params?.result : {} });
                    combineObject.push({ [item.name]: true });
                } else {
                    combineObject.push({ [item.name]: item.value });
                }
            }
            const selectedValue = getSelectedValue(combineObject);
            const input = JSON.parse(obj.input);
            Object.assign(input, selectedValue);
            obj.input = JSON.stringify(input);
            closeModalAndResetState(obj, props.params?.for, id);
        } else if (props.params?.for === PlanFunctionsForFlag.ConfirmNewPartialTrip) {
            let obj = props.params?.obj;
            const input = JSON.parse(obj.input);
            if(parameters[0].type == 'Dialog.ConfirmMultiLine')
                input.warnings = true
            if(parameters[0].type == 'Dialog.ConfirmSingleLine')
                input.confirmation = true
            obj.input = JSON.stringify(input)
            closeModalAndResetState(obj, props.params?.for,props.params?.id);
        } else if (props.params?.for === PlanFunctionsForFlag.MoveAgendaItem) {
            let obj = props.params?.obj;
            const input = JSON.parse(obj.input);
            input.warnings = true
            input.newStartDateTime = props.params?.options?.start
            input.newEndDateTime = props.params?.options?.end
            obj.input = JSON.stringify(input)
            closeModalAndResetState(obj, props.params?.for,props.params?.id);
        } else if (props.params?.for === PlanFunctionsForFlag.PlanMovementsOnAgenda) {
            if (checkFormData(formData)) {
                return;
            }
            const obj = props.params?.obj;
            const combineObject = [];
            for (const item of formData) {
                if (item.type === 'Edm.DateTime') {
                    combineObject.push({ [item.name]: moment(item.value).format(process.env.REACT_APP_DATETIMEFORMAT2)});
                    combineObject.push({ 'planDate': moment(item.value).format(process.env.REACT_APP_DATEFORMAT2)});
                    combineObject.push({ 'planTime': moment(item.value).format(process.env.REACT_APP_TIMEFORMAT)});
                } else if (item.type === 'Dialog.ConfirmSingleLine') {
                    combineObject.push({ [item.name]: item.value });
                } else if (item.type === 'Dialog.SelectRadioButton') {
                    combineObject.push({ [item.name]: item.value == "" ? "" : item.value });
                }  else {
                    combineObject.push({ [item.name]: item.value });
                }
            }
            const selectedValue = getSelectedValue(combineObject);
            const input = JSON.parse(obj.operationDetail[0].input);
            Object.assign(input, selectedValue);
            if([ 'Dialog.SelectRadioButton','Dialog.ConfirmSingleLine'].includes(parameters[0].type))
                input.data = props?.params?.data
            if(parameters[0].type == 'Dialog.ConfirmSingleLine')
                input.confirmation = true
            obj.operationDetail[0].input = JSON.stringify(input);
            closeModalAndResetState(obj, props.params?.for);
        } else if(props.params?.for === PlanFunctionsForFlag.PlanPartialTripOnAgenda) {
            if (checkFormData(formData)) {
                return;
            }
            const obj = props.params?.obj;
            const combineObject = [];
            for (const item of formData) {
                if (item.type === 'Edm.DateTime') {
                    combineObject.push({ [item.name]: moment(item.value).format(process.env.REACT_APP_DATETIMEFORMAT2)});
                    combineObject.push({ 'planDate': moment(item.value).format(process.env.REACT_APP_DATEFORMAT2)});
                    combineObject.push({ 'planTime': moment(item.value).format(process.env.REACT_APP_TIMEFORMAT)});
                } else if (item.type === 'Dialog.ConfirmSingleLine') {
                    combineObject.push({ 'data': props?.params?.result ? props?.params?.result : {} });
                    combineObject.push({ [item.name]: item.value });
                } else {
                    combineObject.push({ [item.name]: item.value });
                }
            }
            const selectedValue = getSelectedValue(combineObject);
            const input = JSON.parse(obj.input);
            Object.assign(input, selectedValue);
            obj.input = JSON.stringify(input);
            closeModalAndResetState(obj, props.params?.for, id);
        } else if (props.params?.for === PlanFunctionsForFlag.CreateTrip) {
            if (checkFormData(formData)) {
                return;
            }

            const combineObject = [];
            for (const item of formData) {
                if (item.stopOnCancel !== null && item.stopOnCancel !== undefined && !item.stopOnCancel) {
                    item.value = true;
                }
                if (item.type === 'Edm.Date') {
                    combineObject.push({ [item.name]: moment(item.value).format('yyyy-MM-DD') });
                } else {
                    combineObject.push({ [item.name]: item.value });
                }
            }

            const selectedValue = getSelectedValue(combineObject);
            setAdditionalValues(selectedValue);
            const obj = service.movementLinesAndOperationDeatilObject(props.params?.movementlines, JSON.stringify(selectedValue));
            closeModalAndResetState(obj, props.params?.for);
        } else if ([PlanFunctionsForFlag.InsertExtraAction,PlanFunctionsForFlag.Remark,PlanFunctionsForFlag.AgendaItem,PlanFunctionsForFlag.ShowDetailsActionItemRemark].includes(props.params?.for)) {
            if (checkFormData(formData)) {
                return;
            }
            const combineObject = [];
            for (const item of formData) {
                if (item.type === 'APIGrid') {
                    combineObject.push({ [item.name]:[PlanFunctionsForFlag.AgendaItem,PlanFunctionsForFlag.ShowDetailsActionItemRemark].includes(props.params?.for) ? item?.value?.code : item?.value?.id });
                } else if (item.type === 'Dialog.SelectRadioButton' || item.type === 'Edm.String') {
                    combineObject.push({ [item.name]: item.value == "" ? "" : item.value });
                } else if (item.type === 'Dialog.SelectMenuSingle') {
                    combineObject.push({ [item.name]: item.value == "" ? "" : item?.value?.name });
                } else if (item.type === 'Edm.Date') {
                    combineObject.push({ [item.name]: moment(item.value).format('yyyy-MM-DD') });
                } else if (item.type === 'Edm.TimeOfDay') {
                    combineObject.push({ [item.name]: moment(item.value).format('HH:mm:ss') });
                } else {
                    combineObject.push({ [item.name]: item.value });
                }
            }
            const selectedValue = getSelectedValue(combineObject);
            let obj = {
                "input": JSON.stringify(selectedValue)
            }
            const parsedInput1 = JSON.parse(props.params?.obj.input);
            const parsedInput2 = JSON.parse(obj.input);
            const mergedInput = { ...parsedInput1, ...parsedInput2 };
            const jsonString = ({ input: JSON.stringify(mergedInput) });

            closeModalAndResetState(jsonString, props.params?.for);
        } else {
            onCloseClick();
        }
    }

    const getSelectedValue = (combineObject) => {
        const selectedValue = combineObject.reduce((result, currentObject) => {
            Object.keys(currentObject).forEach(property => {
                result[property] = result[property] || currentObject[property];
            });
            return result;
        }, {});
        return selectedValue;
    }

    const closeModalAndResetState = (obj, forFlag, id=null) => {
        setFormData([]);
        setYesButton(false);
        props.closeConfirmationModal(obj, forFlag, id);
    }

    const onCloseClick = () => {
        setFormData([]);
        setYesButton(false);
        props?.closeConfirmationModal(null,props.params?.for);
    }

    const onNoClick = () => {
        if (props.params?.for === PlanFunctionsForFlag.CreateTrip) {
            if (checkFormData(formData)) {
                return;
            }

            const combineObject = [];
            for (const item of formData) {
                combineObject.push({ [item.name]: item.value });
            }

            const selectedValue = getSelectedValue(combineObject);
            setAdditionalValues(selectedValue);
            const obj = service.movementLinesAndOperationDeatilObject(props.params?.movementlines, JSON.stringify(selectedValue));
            closeModalAndResetState(obj, props.params?.for);
        } else if (props.params?.for === PlanFunctionsForFlag.ChangePTResourceConfirmation) {
            const obj = props.params?.result;
            obj.warnings = false;
            closeModalAndResetState(obj, props.params?.for);
        } else if (props.params?.for === PlanFunctionsForFlag.SetFree || props.params?.for === PlanFunctionsForFlag.SetFreeRoutes) {
            const combineObject = [];
            for (const item of formData) {
                if (item.type === 'Dialog.ConfirmSingleLine') {
                    if (yesButton) {
                        combineObject.push({ [item.name]: false });
                    } else {
                        combineObject.push({ [item.name]: item.value });
                    }
                }
            }

            const selectedValue = getSelectedValue(combineObject);
            setAdditionalValues(selectedValue);
            const gridFlagVal = props.params?.for === PlanFunctionsForFlag.SetFreeRoutes ? 'routes' : 'movements';
            const obj = service.movementLinesAndOperationDeatilObject(props.params?.movementlines, JSON.stringify(selectedValue), gridFlagVal);
            closeModalAndResetState(obj, props.params?.for);
        } else if (props.params?.for === PlanFunctionsForFlag.MoveMovement) {
            const obj = props.params?.obj;
            const combineObject = [];
            for (const item of formData) {
                if (item.type === 'Dialog.ConfirmSingleLine') {
                    combineObject.push({ [item.name]: item.value });
                } else {
                    combineObject.push({ [item.name]: item.value });
                }
            }
            const selectedValue = getSelectedValue(combineObject);
            const input = JSON.parse(obj.input);
            Object.assign(input, selectedValue);
            obj.input = JSON.stringify(input);
            closeModalAndResetState(obj, props.params?.for, id);
        }
    }

    const checkFormData = (formData) => {
        return formData.some(({ isRequired, value, name }) => name === "planDateTime" ? isRequired : isRequired && !value )
    }

    const setAdditionalValues = (selectedValue) => {
        if (props.params?.input?.tripDate) {
            selectedValue.tripDate = props.params?.input?.tripDate;
        }
        if (props.params?.input?.alreadyPlannedWarning) {
            selectedValue.alreadyPlannedWarning = props.params?.input?.alreadyPlannedWarning;
        }
        if (props.params?.input?.planLimitExceeded) {
            selectedValue.planLimitExceeded = props.params?.input?.planLimitExceeded;
        }
        if (props.params?.data) {
            selectedValue.data = props.params?.data;
        }
        if (props.params?.planOnPartialTrip) {
            selectedValue.planOnPartialTrip = props.params.planOnPartialTrip;
        }
    }

    const renderCancelButton = (formData) => {
        let flag = 0;
        for (const data of formData) {
            if (data.type === 'Dialog.SelectMenuSingle' || data.type === 'Edm.DateTime' || data.type === 'Edm.Date' || data.type === 'Dialog.ConfirmSingleLine'
                || data.type === 'Dialog.ConfirmMultiLine' || data.type === 'Dialog.SelectRadioButton') {
                flag = 1;
                break;
            }
        }
        if (flag === 1) { // || props?.params?.title !== "Error"
            return (
                <Button variant="outlined" onClick={onCloseClick} size="small">
                    Cancel
                </Button>);
        } else {
            return (<></>);
        }
    };

    const renderNoButton = (formData) => {
        let flag = 0;
        for (const data of formData) {
            if (data.type === 'Dialog.ConfirmSingleLine' && !data.stopOnCancel) {
                flag = 1;
                break;
            }
        }
        if (flag === 1) {
            return (
                <Button variant="contained" onClick={onNoClick} size="small">
                    No
                </Button>);
        } else {
            return (<></>);
        }
    };

    const RenderActionButtons = () => {
        return (
            <>
                <Button
                    variant="contained"
                    onClick={onOkClick}
                    size="small"
                >
                    {yesButton ? "YES" : "OK"}
                </Button>
                {renderNoButton(formData)}
                {renderCancelButton(formData)}
            </>
        )
    }

    return (
        <>
            {props?.openConfirmationModal && <WindowComponent title={props?.params?.title} visible={props?.openConfirmationModal} initialWidth={480} initialHeight={230} minWidth={400} minHeight={210} onClose={onCloseClick} dataComponent={WindowContentData} formData={formData} params={props?.params} message={props?.message} actionButtons={<RenderActionButtons />} resizable={true} minimizeButton={() => { return null }} maximizeButton={() => { return null }} doubleClickStageChange={false} />}
        </>
    )
}

const WindowContentData = ({ fromDataParam, params, message, sendDataToParent }) => {
    const [formData, setFormData] = React.useState([]);
    const [hoveredInput ,setHoveredInput] = React.useState(null);
    const [openModalPopUp,setOpenModalPopUp] = React.useState(false);
    const [country,setCountry] = React.useState("");

    const toDayDate = new Date();
    const minDate = new Date(toDayDate.getFullYear() - 50, toDayDate.getMonth(), toDayDate.getDate());
    const maxDate = new Date(toDayDate.getFullYear() + 50, toDayDate.getMonth(), toDayDate.getDate());

    useEffect(() => {
        if (fromDataParam) {
            const tempFormData = fromDataParam;
            setFormData([...tempFormData]);
        }
    }, [fromDataParam]);

    useEffect(() => {
        if (sendDataToParent) {
            setTimeout(() => {
                sendDataToParent('modalPopup');
            }, 100);
        }
    }, [sendDataToParent])

    const onDropDownClose = (e, action) => {
        if (e.nativeEvent.type == "click" || (e.nativeEvent.type == "keydown" && (e.nativeEvent.key == "Enter" || e.nativeEvent.key == "Tab"))) {
            if (action == "delete-depot" || action == "actionId" || action == "agendaCode") {
                handleFormChange(e, action);
            }
        }
    };

    const handleFormChange = (event, field) => {
        if(field == 'country') {
            setCountry(event.value.caption);
            for (const item of formData) {
                if (item.name === "postcode" || item.name === "city") {
                    item.value = "";
                }
            }
        }
        const tempFormData = formData;
        if (event.value !== null && event.value !== undefined && event.value !== '') {
            tempFormData.find(data => data.name.toString() === field.toString()).value = event.value;
            tempFormData.find(data => data.name.toString() === field.toString()).isRequired = false;
        } else {
            tempFormData.find(data => data.name.toString() === field.toString()).value = event.value;
            tempFormData.find(data => data.name.toString() === field.toString()).isRequired = true;
        }
        if(field == 'planDateTime' && [PlanFunctionsForFlag.PlanMovementsOnAgenda,PlanFunctionsForFlag.PlanPartialTripOnAgenda].includes(params.for)) {
            let tempDate = typeof (event?.value) == 'object' ? (service.tempFormat(event?.value)) : (event?.value)
            let newValue = parse(tempDate, process.env.REACT_APP_DATEFORMAT, new Date());
            if (newValue == Consts.InvalidDate || (newValue < minDate) || (newValue > maxDate)) {
                tempFormData.find(data => data.name.toString() === field.toString()).isRequired = true;
            }
        }
        setFormData([...tempFormData]);
    };

    const addAddress = (data) => {
        const tempFormData = formData;
        for (const item of tempFormData) {
            if (item.name === "postcode") {
                item.value = data.code;
            } else if (item.name === "city") {
                item.value = data.city;
            } else if (item.name === "country") {
                item.value = { name: data.country, caption: data.country };
            }
        }
        setFormData([...tempFormData]);
        setOpenModalPopUp(false);
    }

    return (
        <>
            {params?.title === "Error" &&
                <DialogContent sx={{ padding: 2 }} className='ctm-subGrid' id="modalPopup">
                    {message}
                </DialogContent>
            }
            {
                (formData !== null && formData !== undefined && formData.length > 0) &&
                <DialogContent sx={{ padding: 2 }} className='ctm-subGrid' id="modalPopup">
                    <Grid container spacing={1} >
                        {
                            formData?.map((formItem, index) => {
                                if (formItem.type === "Dialog.SelectMenuSingle") {
                                    return (
                                        <Grid item xs={formItem?.columns? formItem?.columns : 6} key={index}>
                                            {formItem.description ? formItem.description : formItem.caption}
                                            <DropDownList
                                                data={formItem.options}
                                                textField="caption"
                                                valueField="name"
                                                onBlur={(e) => handleFormChange(e, formItem.name)}
                                                defaultValue={formItem?.value}
                                                onClose={(e) => handleFormChange(e, formItem.name)}
                                                onChange={(e) => onDropDownClose(e, formItem.name)}
                                                key={formItem.name}
                                                required={true}
                                            />
                                            <p style={{ height: "1px", color: 'red', marginTop: '5px' }}>
                                                {params?.for !== PlanFunctionsForFlag.InsertExtraAction && formItem?.isRequired && (`Please select ${formItem.name}`)}
                                            </p>
                                        </Grid>
                                    );
                                } else if (formItem.type === "Edm.DateTime") {
                                    return (
                                        <Grid item width={300} key={index}>
                                            {formItem.name === 'hookOffDateTime' ? 'Hook Off Time:' :
                                                formItem.name === 'hookOnDateTime' ? 'Hook On Time:' : formItem.name
                                            }
                                            <DateTimePicker
                                                value={formItem.value}
                                                format={"dd-MM-yyyy HH:mm"}
                                                minDate={minDate}
                                                maxDate={maxDate}
                                                onChange={(e) => handleFormChange(e, formItem.name)}
                                                required={true}
                                                key={formItem.name}
                                            />
                                            <p style={{ height: "1px", color: 'red', marginTop: '5px' }}>
                                                {formItem?.isRequired && (`Please select ${formItem.name === 'hookOffDateTime' ? 'Hook Off Time:' :
                                                    formItem.name === 'hookOnDateTime' ? 'Hook On Time:' : formItem.name
                                                    }.`)}
                                            </p>
                                        </Grid>
                                    );
                                } else if (formItem.type === "Edm.TimeOfDay") {
                                    return (
                                        <Grid item width={300} xs={formItem?.columns ? formItem?.columns : 12}  key={index}> 
                                            {formItem.caption}
                                            <TimePicker 
                                                value={formItem.value}
                                                onChange={(e) => handleFormChange(e, formItem.name)}
                                                required={true}
                                                key={formItem.name}
                                                format="HH:mm"
                                            />
                                        </Grid>
                                    )
                                } else if (formItem.type === "Edm.Date") {
                                    return (
                                        <Grid item width={300} xs={formItem?.columns ? formItem?.columns : 12}  key={index}>
                                            {formItem.caption}
                                            <KendoDatePicker
                                                value={formItem.value}
                                                onChange={(e) => handleFormChange(e, formItem.name)}
                                                required={true}
                                                key={formItem.name}
                                                format={"dd-MM-yyyy"}
                                            />
                                            <p style={{ height: "1px", color: 'red', marginTop: '5px' }}>
                                                {formItem?.isRequired && (`Please select ${formItem.name}.`)}
                                            </p>
                                        </Grid>
                                    );
                                } else if (formItem.type === "Dialog.Message") {
                                    return (
                                        <Grid item sx={{maxHeight:'500px'}} xs={12} style={{ whiteSpace: "pre-wrap" }} key={index}>
                                            {formItem.description}
                                        </Grid>
                                    );
                                } else if (formItem.type === "Dialog.ConfirmSingleLine") {
                                    return (
                                        <Grid item xs={12} style={{ whiteSpace: "pre-wrap" }} key={index}>
                                            {formItem.content}
                                        </Grid>
                                    );
                                } else if (formItem.type === 'Dialog.ConfirmMultiLine') {
                                    return (
                                        <Grid item xs={12} style={{ whiteSpace: "pre-wrap" }} key={index}>
                                            <List sx={{ listStyleType: 'disc', p: 0, minWidth: "340px" }} >
                                                {formItem.lines.map((item, lineIndex) => {
                                                    return (<ListItem sx={{ fontSize: "16px" }} key={lineIndex}>
                                                        <ListItemIcon sx={{ minWidth: "25px" }}>
                                                            <CircleIcon sx={{ fontSize: "14px" }} />
                                                        </ListItemIcon>
                                                        {item.content}
                                                    </ListItem>)
                                                })
                                                }
                                            </List>
                                        </Grid>
                                    );
                                } else if (formItem.type === 'Dialog.SelectRadioButton') {
                                    return (
                                        <Grid item width={300} key={index}>
                                            {/* {
                                                formItem.options.map(option => {
                                                    return (<Box width={300} sx={{ mb: 1.5 }} key={option.name}>
                                                        <RadioButton
                                                            name={formItem.name}
                                                            value={option.name}
                                                            defaultChecked={formItem.value === option.name}
                                                            label={option.caption}
                                                            onChange={(e) => handleFormChange(e, formItem.name)}
                                                            key={option.caption}
                                                        />
                                                    </Box>)
                                                })                                               
                                            } */}
                                             <RadioGroup name={formItem.name} onChange={(e) => handleFormChange(e.target,formItem.name)}>
                                                {formItem.options.map((option) => (
                                                  <Box key={option.name}>
                                                    <FormControlLabel
                                                      value={option.name}
                                                      control={<Radio checked={option.name === formItem.value} />}
                                                      label={option.caption}
                                                    />
                                                  </Box>
                                                ))}
                                              </RadioGroup>
                                            <p style={{ height: "1px", color: 'red', marginTop: '5px' }}>
                                                {formItem?.isRequired && ("Please select an action.")}
                                            </p>
                                        </Grid>
                                    );
                                } else if (formItem.type === 'APIGrid' && (formItem.name === 'actionId' || formItem.name === 'agendaCode' )) {
                                    return (
                                        <Grid item width={300} s={formItem?.columns ? formItem?.columns : 12} key={index}>
                                            <DropDownList
                                                data={params?.options}
                                                textField={[PlanFunctionsForFlag.AgendaItem,PlanFunctionsForFlag.ShowDetailsActionItemRemark].includes(params?.for)?"code":"codeAction"}
                                                valueField={[PlanFunctionsForFlag.AgendaItem,PlanFunctionsForFlag.ShowDetailsActionItemRemark].includes(params?.for)?"code":"id"}
                                                value={formItem.value}
                                                onBlur={(e) => handleFormChange(e, formItem.name)}
                                                defaultValue={formItem?.value}
                                                onClose={(e) => handleFormChange(e, formItem.name)}
                                                onChange={(e) => onDropDownClose(e, formItem.name)}
                                                key={formItem.name}
                                                required={true}
                                            />
                                            <p style={{ height: "1px", color: 'red', marginTop: '5px' }}>
                                                {formItem?.isRequired && (`Please select ${formItem.entityName}`)}
                                            </p>
                                        </Grid>
                                    );
                                } else if (formItem.type === 'Edm.String') {
                                    return (
                                        <Grid item sx={{ position: 'relative' }} xs={formItem?.columns ? formItem?.columns : 12} key={index}onMouseEnter={() => setHoveredInput(formItem.name)} onMouseLeave={() => setHoveredInput(null)}>
                                            {formItem?.caption && <Typography variant="body2" sx={{ pr: 0.5, width: 107 }}>{formItem.caption} :</Typography>}
                                            <input
                                                type="text"
                                                value={formItem?.value}
                                                className="form-control input-width"
                                                onChange={(e) => handleFormChange(e.target, formItem.name)}
                                                // onMouseEnter={() => setHoveredInput(formItem.name)} // Track hover
                                                // onMouseLeave={() => setHoveredInput(null)}
                                                name={formItem.name}
                                                autoComplete="off"
                                            />
                                            {
                                                ["postcode", "city"].includes(formItem.name) && (
                                                    <IconButton disabled={formItem.name !== hoveredInput} sx={{ position: 'absolute', right: 0, padding: 0 }} size="large" aria-label="show 4 new mails" color="inherit" onClick={() => setOpenModalPopUp(true)}>
                                                        <ArrowDropDownIcon />
                                                    </IconButton>
                                                )
                                            }
                                        </Grid>
                                    );
                                } else if (formItem.type === "Label") {
                                    return (
                                        <Grid item xs={formItem?.columns ? formItem?.columns : 12} key={index}>
                                            <Typography variant="body2" sx={{ pr: 1 }}>{formItem?.caption + ' '}</Typography>
                                        </Grid>
                                    )
                                } else {
                                    return (<></>);
                                }
                            })
                        }
                    </Grid>
                </DialogContent>
            }

            {openModalPopUp && <WindowComponent isPopup={true} title={"Select Postal Code"} visible={openModalPopUp} isWindowContent={true} initialWidth={1000} initialHeight={700} minWidth={300} minHeight={500} params={params} country={country} addAddress={addAddress} onClose={() => setOpenModalPopUp(false)} />}
        </>
    )
}

export default ModalComponent;